import { Modal } from "antd";
import { useBoolean } from "hooks/useBoolean";
import Button from "Components/Button";
import { useOrder } from "hooks/OrderManagement/useOrders";
import { useState } from "react";

type MarkAsShippedProps = {
  orderId: string;
};
export const MarkAsShipped = ({ orderId }: MarkAsShippedProps) => {
  const [showModal, setModal] = useBoolean(false);

  const [note, setNotes] = useState("");

  const { refetch, markOrderAsShippedLoading, markOrderAsShipped } =
    useOrder(orderId);

  if (!orderId) return null;

  return (
    <div>
      <Button label="Marked as Delivered" onClick={setModal.on} />
      <Modal
        open={showModal}
        onCancel={setModal.off}
        closable={false}
        footer={null}
      >
        <div className="mb-1 font-semibold">Enter Notes (Optional)</div>
        <textarea
          placeholder="Enter notes here..."
          value={note}
          onChange={(e) => setNotes(e.target.value)}
          className="mb-3 py-[20px] px-[15px] h-[200px] rounded-md border-[1px] border-[#eeeeee] resize-none w-full"
        />
        <Button
          isLoading={markOrderAsShippedLoading}
          onClick={() => {
            markOrderAsShipped(
              {
                note,
              },
              {
                onSuccess: () => {
                  refetch();
                  setNotes("");
                  setModal.off();
                },
              }
            );
          }}
          label="Submit"
        />
      </Modal>
    </div>
  );
};
